import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { ErrorPage } from "@/pages/ErrorPage";

import Layout from "@/components/Layout";
import ProtectedApp from "@/components/ProtectedApp";
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import LandingPage from "@/pages/LandingPage";
import PrintableReportPage from "@/pages/PrintableReportPage";
import PublicViewPage from "@/pages/PublicViewPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import EulaPage from "@/pages/EulaPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import AnalysisExclusionsPage from "@/pages/AnalysisExclusionsPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Layout>
        <ProtectedApp />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/signup",
    element: (
      <Layout>
        <SignupPage />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/login",
    element: (
      <Layout>
        <LoginPage />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/forgotpassword",
    element: (
      <Layout>
        <ForgotPasswordPage />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/end-user-agreement",
    element: (
      <Layout useMyLotLogo>
        <EulaPage />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/privacy-policy",
    element: (
      <Layout useMyLotLogo>
        <PrivacyPolicyPage />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/analysis-exclusions",
    element: (
      <Layout useMyLotLogo>
        <AnalysisExclusionsPage />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/reset-password",
    element: (
      <Layout>
        <ResetPasswordPage />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "yarra-ranges",
    element: <LandingPage />,
  },
  {
    path: "report",
    element: <PublicViewPage />,
  },
  {
    path: "print",
    element: <PrintableReportPage />,
  },
]);

export function Router() {
  return <RouterProvider router={router} />;
}
